import styled from 'styled-components';

/* ── Section wrapper ─────────────────────────────────────── */
export const Container = styled.section`
  background: #FFFAF2;
  padding: 120px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

/* ── Inner grid ──────────────────────────────────────────── */
export const GridContainer = styled.div<{ isMobile: boolean }>`
  max-width: 1200px;
  width: 100%;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;

  @media (max-width: 1024px) {
    gap: 60px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;

    & > :last-child {
      order: -1;
    }
  }
`;

/* ── Text side ───────────────────────────────────────────── */
export const ContentContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 550px;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
    max-width: none;
    margin: 0 auto;
  }
`;

export const Title = styled.h2<{ isMobile: boolean }>`
  font-family: 'Mulish', Helvetica, sans-serif;
  font-weight: 700;
  font-size: 56px;
  line-height: 1.15;
  color: #1B170C;
  margin: 0;
  letter-spacing: -0.02em;

  @media (max-width: 1024px) {
    font-size: 44px;
  }

  @media (max-width: 768px) {
    font-size: 36px;
    line-height: 1.25;
  }

  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

export const Description = styled.p<{ isMobile: boolean }>`
  font-family: 'Mulish', Helvetica, sans-serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.7;
  color: #393324;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 1.8;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

/* ── Image side ──────────────────────────────────────────── */
export const ImageContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    order: -1;
  }
`;

export const Image = styled.img<{ isMobile: boolean }>`
  max-width: 100%;
  height: auto;
  max-height: 560px;
  object-fit: contain;
  transition: transform 0.4s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    max-height: 440px;
  }
`;
